import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Loader from "../../../../Widgets/Loader/Loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { checkStage2DocumentsUploadedListed, postAddFileOfSubmittedApplicationsOfViewUpdateApplicationForm } from "../../../../../api";

const AddImageModal = ({
  current_stage,
  show,
  onHide,
  pointerID,
  getAllDataOfSubmittedApplicationsFunction,
  stage,
  empID = ""
}) => {
  const [formValues, setFormValues] = useState({
    file: null,
    error: "",
    fileError: false,
    fileName: "", // Stores the file name
  });

  const [isEnabledArea, setIsEnabledArea] = useState(0);
  const [stageDocuments, setStageDocuments] = useState([
    // { id: 1, document_name: "Document 1" },
    // { id: 2, document_name: "Document 2" },
    // { id: 3, document_name: "Document 3" },
  ]);

  const [selectedDocumentId, setSelectedDocumentId] = useState("");

  const [newDocumentName, setNewDocumentName] = useState("");

  const [errorFileName, setErrorFileName] = useState(false);

  const [validAcceptFiles, setValidAcceptFiles] = useState(".pdf,.jpg,.jpeg,.png,.heic,.xlx,.xlsx");

  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const document_allow = [
    "pdf",
    "png",
    "jpg",
    "jpeg",
    "hei",
    "mp3",
    "mp4",
    "xls",
    "xlxs"
  ];


  // Convert document required types to valid MIME types
  const getValidFileTypes = () => {
    const fileTypeMap = {
      pdf: "application/pdf",
      png: "image/png",
      jpg: "image/jpg",
      jpeg: "image/jpeg",
      heic: "image/heic",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    };

    // Ensure selectedDoc?.document_required is an array before mapping
    return (document_allow || []).map(type => fileTypeMap[type]).filter(Boolean);
    // return document_allow.map(type => fileTypeMap[type]).filter(Boolean);
  };

  const validFileTypes = getValidFileTypes();

  // Create dynamic list of supported file types for display
  const getSupportedFileTypesText = () => {
    // const extensionMap = {
    //   "application/pdf": ".pdf",
    //   "image/png": ".png",
    //   "image/jpg": ".jpg",
    //   "image/jpeg": ".jpeg",
    //   "image/heic": ".heic",
    //   "application/vnd.ms-excel": ".xls",
    //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
    // };



    // return validFileTypes.length > 0
    //   ? validFileTypes.map(type => extensionMap[type]).join(",")
    //   : "No supported file types available";
    return validAcceptFiles;
    // return document_allow.join(",");
  };

  // console.log(getSupportedFileTypesText);


  // const getSupportedFileTypesText_New = () => {
  //   const extensionMap = {
  //     "application/pdf": ".pdf",
  //     "image/png": ".png",
  //     "image/jpeg": ".jpg / .jpeg",
  //     "image/heic": ".heic",
  //     "audio/mpeg": ".mp3",
  //     "video/mp4": ".mp4",
  //     "application/vnd.ms-excel": ".xls",
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
  //   };



  //   return validFileTypes.length > 0
  //     ? validFileTypes.map(type => extensionMap[type]).join(" / ")
  //     : "No supported file types available";

  //   // return document_allow.join(",");
  // };

  const onChangeStageDocument = (e) => {
    const selectedDocId = e.target.value;
    console.log(selectedDocId, "selectedDocId");
    setSelectedDocumentId(selectedDocId);
    if(selectedDocId === '18' || selectedDocId === '30' || selectedDocId === '42'){
      setIsEnabledArea(2);
      console.log("isEnabledArea set to 2");
    } else {
      setIsEnabledArea(1);
      console.log("isEnabledArea set to 1");
    }
    
    // Pick the valid type present in stageDocuments key as allowed_type as json string
    const allowed_type = stageDocuments.find(doc => doc.id.toString() === selectedDocId)?.allowed_type || '[]';
    console.log(allowed_type, "allowed_type");

    // Parse the JSON string to get an array
    let allowedTypesArray = [];
    try {
      allowedTypesArray = JSON.parse(allowed_type);
    } catch (error) {
      console.error("Error parsing allowed_type JSON:", error);
    }
    console.log(allowedTypesArray, "allowedTypesArray");

    // Create a comma-separated string for the accept attribute
    const acceptString = allowedTypesArray.map(type => `.${type}`).join(",");
    console.log(acceptString, "acceptString");

    setValidAcceptFiles(acceptString);
    //
    // setValidAcceptFiles(".pdf,.jpg,.jpeg,.png,.heic,.mp3,.mp4,.xls,.xlsx");
    // You can use the selectedDocId to fetch or set related data as needed
  }

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    console.log(selectedFile.type, "selectedFile.type");
    console.log(validFileTypes, "validFileTypes");


    const validFileTypes1 = [
      "application/pdf",
      "image/png",
      "image/jpg",
      "image/jpeg",
      "image/heic",
      "audio/mpeg",
      "video/mp4",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    // return;
    if (selectedFile) {
      if (validFileTypes1.includes(selectedFile.type)) {
        const filePreview = {
          file: selectedFile,
          preview: URL.createObjectURL(selectedFile), // Generate URL for both image and PDF files
        };

        setFormValues({
          file: filePreview,
          error: "",
          fileError: false,
          fileName: selectedFile.name, // Update the fileName with selected file name
        });
      } else {
        setFormValues({
          file: null,
          error: "Unsupported file type. Please select a valid file type.",
          fileError: true,
          fileName: "",
        });

        // Show toast notification for invalid file type
        toast.error("Unsupported file type. Please select a valid file type.");
      }
    }
  };

  const handleSubmit = async () => {

    setErrorFileName(false);
    if (newDocumentName === "" && (isEnabledArea === 2)) {
      setErrorFileName(true);
      // setFormValues({
      //   ...formValues,
      //   error: "Please select a file to upload.",
      //   fileError: true,
      // });
      return;
    }

    if (!formValues.file) {
      setFormValues({
        ...formValues,
        error: "Please select a file to upload.",
        fileError: true,
      });
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      if (formValues.file) {
        formData.append("file", formValues.file.file);
      }
      formData.append("stage", stage);
      formData.append("pointer_id", pointerID);
      formData.append("document_name", newDocumentName);
      formData.append("employee_id", (empID === "") ? 0 : empID);
      formData.append("required_id", selectedDocumentId);
      


      const response =
        await postAddFileOfSubmittedApplicationsOfViewUpdateApplicationForm(
          formData
        );

      setLoading(false);

      if (
        response &&
        response?.data &&
        response?.data?.response &&
        response?.data?.response?.response === true &&
        response?.data?.response?.data
      ) {
        toast.success(
          response?.data?.response?.success_msg || "Updated Successfully."
        );

        getAllDataOfSubmittedApplicationsFunction();
        onHide();
      } else {
        setLoading(false);
        console.error(
          "Error in Saving",
          response?.data?.error_msg || "Unknown error"
        );
        toast.error(response?.data?.response?.error_msg || "Error in Deleting");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error in Updated", error);
    }
  };

  const callValidDocumentsDropdown = () => {
    // Logic to fetch and set documents for the dropdown
    // For now, using static data
    setLoading(true);
    try {
      const employee_id = (empID === "") ? 0 : empID;
      checkStage2DocumentsUploadedListed(pointerID, "employment_documents", employee_id).then((response) => {
        if (response && response.data && response.data.response && response.data.response.response === true) {
          setStageDocuments(response.data.response.data);

          setIsEnabledArea(1);
          setLoading(false);


          if(response.data.response.data.length === 1){
            // set Other of all options
            setIsEnabledArea(2);  

            response.data.response.data[0].id && setSelectedDocumentId(response.data.response.data[0].id);
            console.log("Only one document available, setting isEnabledArea to 2 and selectedDocumentId to ", response.data.response.data[0].id);

          }

          
        } else {
          setIsEnabledArea(2);
        }
      });
    } catch (error) {
      console.error("Error fetching stage 2 documents:", error);
      setIsEnabledArea(2);
    }
    
  };


  useEffect(() => {
    // When Stage is stage_2, enable the document selection dropdown
    if (stage === 'stage_2') {
      callValidDocumentsDropdown();
      setSelectedDocumentId("");
      console.log("Stage is stage_2, fetching documents for dropdown");
    } 
  }, [show]);



    useEffect(() => {
    if (show) {
      setFormValues({
        file: null,
        error: "",
        fileError: false,
        fileName: "",
      });
  
      // Also clear the actual file input value
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  }, [show]);




  return (
    <>
      {loading && <Loader />}

      <Modal show={show} onHide={onHide} centered>
        <Modal.Header>
          <Modal.Title className="modal-title text-center text-green">
            Add New Document
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>



          <Form>
            <Form.Group controlId="formFile">

              {(stage === 'stage_2') && (

                <div className="w-100 mb-3">
                  <Form.Label>Select Document</Form.Label>

                  <select className="form-select" onChange={onChangeStageDocument} value={selectedDocumentId}>
                    <option disabled value="" selected>Select Document</option>
                    {stageDocuments.map((doc) => (
                      <option key={doc.id} value={doc.id}>{doc.document_name}</option>
                    ))}
                  </select>
                </div>

              )}


              {(isEnabledArea === 2 || stage !== 'stage_2') && (
              
              <div className="w-100 mb-3">
                <Form.Label>Document Name</Form.Label>
                <input type="text" className="form-control" value={newDocumentName} onChange={(e) => {
                  setNewDocumentName(e.target.value);
                }} />
                {errorFileName && (
                  <p className="text-danger">Document Name Cannot be empty</p>
                )}
              </div>
              )}

              {/* <Form.Label>Upload a file</Form.Label> */}

              <div className="d-flex w-100">
                {/* Hidden file input */}
                <input
                  type="file"
                  className={`form-control ${formValues.fileError ? "is-invalid" : ""}`}
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  style={{ display: "none" }} // Hides the default input
                  id="hiddenFileInput"
                  accept={getSupportedFileTypesText()}
                />

                {/* Custom input field to show file name */}
                <input
                  type="text"
                  className="form-control"
                  placeholder="Choose file..."
                  value={formValues.fileName || ""}
                  readOnly
                  onClick={() => fileInputRef.current.click()} // Triggers file input on click
                  style={{
                    cursor: "pointer", // Adds a pointer cursor
                    backgroundColor: "white", // Sets background to white
                    flexGrow: 1, // Makes input take up remaining space
                  }}
                />

                <Button
                  variant="outline-secondary"
                  onClick={() => fileInputRef.current.click()}
                  className="ms-2"
                >
                  Browse
                </Button>
              </div>


              <Form.Text className="text-danger">
                Only: {getSupportedFileTypesText()}
              </Form.Text>
              {formValues.fileError && (
                <div className="invalid-feedback">{formValues.error}</div>
              )}
            </Form.Group>

            {/* Preview Section */}
            {formValues.file && (
              <div className="mt-3">
                <strong>Preview: </strong>
                {formValues.file.file.type === "application/pdf" ? (
                  <iframe
                    src={formValues.file.preview}
                    title="PDF Preview"
                    style={{
                      width: "100%",
                      height: "300px",
                      border: "none",
                      borderRadius: "8px",
                    }}
                  />
                ) : formValues.file.file.type.startsWith("image/") ? (
                  <img
                    src={formValues.file.preview}
                    alt="Preview"
                    style={{
                      maxWidth: "100%",
                      height: "300px",
                      objectFit: "contain",
                      borderRadius: "8px",
                    }}
                  />
                ) : formValues.file.file.type.startsWith("video/") ? (
                  <video
                    src={formValues.file.preview}
                    controls
                    style={{
                      width: "100%",
                      height: "300px",
                      borderRadius: "8px",
                    }}
                  />
                ) : formValues.file.file.type.startsWith("audio/") ? (
                  <audio
                    src={formValues.file.preview}
                    controls
                    style={{
                      width: "100%",
                    }}
                  />
                ) : (
                  <p>Unsupported file type for preview</p>
                )}
              </div>
            )}
          </Form>



        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-danger ms-1"
            style={{ padding: "7px 20px", borderRadius: "6px", border: "none" }}
            onClick={onHide}
          >
            Close
          </Button>
          <Button
            className="btn_modal"
            style={{ padding: "7px 20px", borderRadius: "6px", border: "none" }}
            onClick={handleSubmit}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddImageModal;
